module.exports = __webpack_public_path__ + "static/media/Animal.31fdba29.svg";